import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { Card } from "@ebsco-ui/ebsco-ui";
import SuccessIndicator from "../success-indicator";

import "./success-indicator-card.scss";

const SuccessIndicatorCard = ({ children, title }) => {
  const ref = useRef();
  useEffect(() => {
    ref.current.focus();
  }, []);
  return (
    <div tabIndex="-1" ref={ref} className="success-indicator-card">
      <Card border="all" isRounded={true} isRaised={true} isTransparent={false}>
        <SuccessIndicator title={title}>{children}</SuccessIndicator>
      </Card>
    </div>
  );
};

SuccessIndicatorCard.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string.isRequired
};

export default SuccessIndicatorCard;
